module.exports = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


//# sourceMappingURL=ja-JP.main.js.map
